<template>
    <div class="container">
        <el-bread-cumb :bread-cumb="breadCumb"></el-bread-cumb>
        <div class="">
            <el-form :model="noticeForm" :rules="rules" ref="noticeForm" label-width="100px">
                <el-form-item label="标题" prop="title">
                    <el-input type="text" v-model="noticeForm.title" auto-complete="off" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="notice">
                    <editor v-on:callback="receiveContent"></editor>
                    <!--<vue-editor v-model="noticeForm.notice" useCustomImageHandler @imageAdded="handleImageAdded"></vue-editor>-->
                    <!--<el-input type="text" v-model="noticeForm.notice" auto-complete="off" placeholder="请输入公告内容"></el-input>-->
                </el-form-item>
                <el-form-item label="结束时间" prop="end_time">
                    <el-date-picker
                            v-model="noticeForm.end_time"
                            type="datetime"
                            placeholder="请选择结束时间" style="width: 100%">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio class="radio" v-model="noticeForm.status" label="1">显示</el-radio>
                    <el-radio class="radio" v-model="noticeForm.status" label="2">不显示</el-radio>
                </el-form-item>
                <el-form-item label=" ">
                    <el-button type="primary" :loading="loading" @click="submitForm('noticeForm')">新增</el-button>
                    <el-button @click="resetForm('noticeForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import ElBreadCumb from '../../../components/BreadCumb.vue';
    import Editor from '../../../components/Editor.vue';

    export default {
        components: { ElBreadCumb, Editor },
        data() {
            return {
                loading: false,
                noticeForm: {
                    title: '',
                    notice: '',
                    end_time: '',
                    status: '1',
                    owner: ''
                },
                rules: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' },
                    ],
                    notice: [
                        { required: true, message: '请输入公告内容', trigger: 'blur' },
                    ],
                    end_time: [
                        { required: true, message: '请选择结束时间', trigger: 'blur', type: 'date' },
                    ]
                },
            };
        },
        created (){

        },
        computed: {
            breadCumb: function(){
                return [{'name':'公告管理','path':`/system/notice/list/${this.$route.params.ruleId}`},{'name':'新增','path':''}]
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.noticeForm.end_time) this.noticeForm.end_time = moment(this.noticeForm.end_time).format('YYYY-MM-DD HH:mm:ss');
                        this.loading = true;
                        this.noticeForm.owner = this.$store.getters.username;
                        this.$api.post(this.$apiUrl.addNotice,{...this.noticeForm},(res)=>{
                            this.loading = false;
                            this.$message.success('新增成功');
                            this.$router.push({path:`/system/notice/list/${this.$route.params.ruleId}`})
                        },(res)=>{
                            this.loading = false;
                            this.$message(res.msg);
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            receiveContent: function (text) {
                this.noticeForm.notice = text;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// add.vue?a6c74296